/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Spaces_Modular_Wizard_Depends_OnInputs */



/**
* | output |
* | --- |
* | "Choose {field} first." |
*
* @param {Spaces_Modular_Wizard_Depends_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_depends_on = /** @type {((inputs: Spaces_Modular_Wizard_Depends_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Depends_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wähle zuerst ${i?.field}.`)
	return /** @type {LocalizedString} */ (`Choose ${i?.field} first.`)
});